























import { faEllipsisV } from '@fortawesome/free-solid-svg-icons'
import { defineComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  props: {
    variant: {
      type: String,
      default: '',
      required: false
    },
    btnStyle: {
      type: String,
      default: '',
      required: false
    }
  },
  data: () => ({
    popUpOpen: false,
    icons: {
      ellipsis: faEllipsisV
    }
  }),
  methods: {
    showPopup(e) {
      if (e) {
        e.stopPropagation()
      }
      this.popUpOpen = true
    },
    hidePopup(e) {
      if (e) {
        e.stopPropagation()
      }
      this.popUpOpen = false
    }
  }
})
